export interface IconProps {
  height?: string;
  width?: string;
  color: string;
  url: string;
  onPress?: (e: React.MouseEvent<HTMLDivElement>) => void;
  customClass?: string;
}

export function Icon({
  height = "3.125rem",
  width = "3.125rem",
  color,
  url,
  onPress = () => {},
  customClass = "",
}: IconProps) {
  return (
    <div
      onClick={onPress}
      style={{
        cursor: onPress !== undefined ? "pointer" : "",
        backgroundColor: color,
        maskImage: `url(${url})`,
        WebkitMaskImage: `url(${url})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
        maskSize: `${width} ${height}`,
        WebkitMaskSize: `${width} ${height}`,
        height,
        width,
        flexShrink: "0",
      }}
      role="presentation"
      className={customClass}
    />
  );
}
